import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lience-reuest-form',
  templateUrl: './lience-reuest-form.component.html',
  styleUrls: ['./lience-reuest-form.component.css']
})
export class LienceReuestFormComponent implements OnInit {
  title="License Request";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/lience-reuest/lience-reuest-form/lience-reuest-form.component.ts